export default __webpack_public_path__ + "static/media/landin-blockimg12.2a3e4940.png";